import { createRouter, createWebHistory } from "vue-router";
import store from "../store";

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/auth",
    name: "auth",
    component: () => import("../views/AuthView.vue"),
    meta: { requiresGuest: true },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("../views/DashboardView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/users",
    name: "users",
    component: () => import("../views/UsersView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/cars",
    name: "cars",
    component: () => import("../views/CarsView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customers",
    name: "customers",
    component: () => import("../views/CustomersView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("../views/ProfileView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/pending-payments",
    name: "pendingPayments",
    component: () => import("../views/PendingPaymentsView.vue"),
    meta: { requiresAuth: true }, // Removed requiresAdmin
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Route guards
router.beforeEach(async (to, from, next) => {
  // Always initialize auth state on first load or when user state is unknown
  if (store.state.user === null && !store.state.loading) {
    try {
      await store.dispatch("initializeAuth");
    } catch (error) {
      console.error("Auth initialization error:", error);
    }
  }

  // Wait for auth state to be determined
  if (store.state.loading) {
    // Show loading while determining auth state
    next();
    return;
  }

  const isAuthenticated = store.getters.isAuthenticated;

  // Check if route requires authentication
  if (to.meta.requiresAuth && !isAuthenticated) {
    next("/auth");
    return;
  }

  // Check if route requires guest (not authenticated)
  if (to.meta.requiresGuest && isAuthenticated) {
    next("/dashboard");
    return;
  }

  // Check if route requires admin access
  if (to.meta.requiresAdmin && isAuthenticated) {
    const isAdmin = store.getters.isAdmin;
    if (!isAdmin) {
      next("/dashboard");
      return;
    }
  }

  next();
});

export default router;
